import { getQueryStringPair, queryToString } from '../../../../assets/src/scripts/modules/query-url'

const App = {
	block: null,
	innerBlock: null,
	loadMoreBtn: null,
	loadMoreBtnWrapper: null,
	data: {
		options: {},
		page: 1,
		totalCount: 0,
		mainTerm: '',
		subTerm: ''
	},
	state: {		
		windowWidth: 0,
		windowHeight: 0,
		loading: true
	},

	// setters & getters
	set loading(val) {
		this.state.loading = val
		this.listenerLoading()
	},

	get loading() {
		return this.state.loading
	},

	get params() {
		let options = this.data.options

		let params = {
			posts_per_page: options.desktopPostsPerPage,
			paged: this.data.page,
		};

		if (typeof options.taxonomy) {
			params.tax_query = []
			const taxonomies = options.taxonomy.split('|')
			const taxField = options.taxField.split('|')
			const taxTerms = options.taxTerms

			taxonomies.forEach((tax, index) => {

				const field = typeof taxField[index] !== 'undefined' ? taxField[index] : 'slug'
				let terms = []

				if ( typeof taxTerms !== 'undefined' && !this.data.mainTerm ) {
					terms.push(taxTerms)
				} else {
					terms.push(this.data.mainTerm)
				}

				params.tax_query.push({
					taxonomy: tax,
					field: field,
					terms: terms,
					operator: 'IN'
				})

				if ( this.data.subTerm ) {
					params.tax_query.push({
						taxonomy: tax,
						field: field,
						terms: this.data.subTerm,
						operator: 'IN'
					})
				}
			})
		}

		// mobile
		if ( window.innerWidth < 768 ) {
			params.posts_per_page = options.mobilePostsPerPage
		} else if (window.innerWidth >= 768 && window.innerWidth <= 1200) {
			params.posts_per_page = options.tabletPostsPerPage
		}

		return params;
	},

	// listeners
	listenerLoading: function() {
		if (this.loading) {
			this.loadMoreBtn.classList.add('loading')
		} else {
			this.loadMoreBtn.classList.remove('loading')
		}
	},

	// methods
	request: function(action, params) {
		return new Promise((resolve, reject) => {

			const formData = new FormData()
			formData.append('action', action)
			formData.append('nonce', menu.nonce)
			formData.append('params', JSON.stringify(params))
			const data = new URLSearchParams(formData)

			fetch(menu.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
					'Cache-Control': 'no-cache',
				},
				body: data
			})
			.then(response => response.json())
			.then(data => {
				resolve(data)
			})
			.catch(error => {
				reject(error)
			})
		})
	},

	reset: function() {
		if (this.loadMoreWrapper)
			this.loadMoreWrapper.classList.remove('disabled')

		this.innerBlock.innerHTML = ''
		this.data.page = 1
		this.data.totalCount = 0
	},

	buildGrid: function(response) {
		let content = document.createRange().createContextualFragment(response.html)

		if (this.data.options.transitionContainer) {
			const gridContainer = document.createElement('div')
			gridContainer.classList.add('post-grid', `grid-${response.data.count}`)
			gridContainer.appendChild(content)
			this.innerBlock.appendChild(gridContainer)
		} else {
			this.innerBlock.appendChild(content)
		}

		this.data.page++
		this.data.totalCount = this.data.totalCount + response.data.count

		if ( this.data.totalCount === response.data.total ) {
			if (this.loadMoreWrapper)
				this.loadMoreWrapper.classList.add('disabled')
		}
	},

	initPopup: function() {
		const items = this.innerBlock.querySelectorAll('.post-item')
        console.log("hellooooooooooooooooooooooooooooo");
		if ( items.length > 0 ) {
			items.forEach(el => {
				el.addEventListener('click', (e) => {

					const params = {
						post: el.dataset.postId
					}
					const action = menu.getItemById
					this.block.classList.add('menu-popup-loading')

					this.request(action, params)
					.then(response => {
						let closeBtn = document.createElement('button')
						closeBtn.classList.add('tingle-modal__close')
						closeBtn.innerHTML = '×'
						let content = document.createRange().createContextualFragment(response.html)
						
						content.prepend(closeBtn)
						// document.querySelector('.tingle-modal-box').append(closeBtn)

						content.prepend(closeBtn)

						const modal = new tingle.modal({
							footer: false,
							closeMethods: ['overlay', 'button', 'escape'],
							closeLabel: 'Close',
							cssClass: [ 'menu-popup' ]
						})

						modal.setContent(content)

						modal.open();
						
						closeBtn.addEventListener('click', e => {
							e.preventDefault()
							modal.close()
						})
					})
					.finally(() => {
						this.loading = false
						this.block.classList.remove('menu-popup-loading')
					})

					e.preventDefault()
				})
			});
		}
	},

	loadList() {
		this.loading = true

		const params = this.params
		const action = menu.getItems

		this.request(action, params)
		.then(response => {
			this.buildGrid(response)
			this.initPopup()
			consol.log("loading...")
		})
		.finally(() => {
			this.loading = false
		})
	},

	initLoadMore: function() {
		this.loadMoreBtn.addEventListener('click', (e) => {
			e.preventDefault()

			this.loadList()
		})
	},

	initFilters: function() {
		const mainFilters = this.block.querySelectorAll('.main-filter')
		const subFilters = this.block.querySelectorAll('.sub-filter')
		const subMenuLabel = this.block.querySelector('.sub-menu-label span')
		const subMenuDropdown = this.block.querySelector('#sub-menu-dropdown')

		mainFilters.forEach((filter) => {
			filter.addEventListener('click', (e) => {

				const li = e.target.closest('li')

				subMenuLabel.innerHTML = 'All'
				subMenuDropdown.checked = false

				mainFilters.forEach(e => e.classList.contains('filter-active') && e.classList.remove('filter-active'))
				


				subFilters.forEach(e => {
					const current = e.classList

					e.classList.remove('filter-active')
					

					if ( !current.contains(`parent-${li.dataset.termId}`) && !current.contains('filter-all') ) {
						e.classList.add('hide-term')
					} else if (current.contains('filter-all')) {
						e.classList.add('filter-active')
						
					} else {
						e.classList.remove('hide-term')
					}
				})

				this.data.mainTerm = li.dataset.term
				this.data.subTerm = ''
				li.classList.add('filter-active')

				if ( !this.block.classList.contains('acf-block-preview') ) {
					const queryParams = getQueryStringPair(window.location.search)
					queryParams.menu_category = this.data.mainTerm

					history.replaceState(null, null, `?${queryToString(queryParams)}`)
				}

				this.reset()
				this.loadList()
			})
		})

		subFilters.forEach((filter) => {
			filter.addEventListener('click', (e) => {

				subFilters.forEach(e => e.classList.contains('filter-active') && e.classList.remove('filter-active'))

				const li = e.target.closest('li')

				this.data.subTerm = li.dataset.term
				li.classList.add('filter-active')

				if (li.dataset.term == '') {	
					subMenuLabel.inerHTML = 'All'
				} else {
					subMenuLabel.innerHTML = li.innerHTML
				}

				subMenuDropdown.checked = false

				this.reset()
				this.loadList()
			})
		})
	},

	filterDropdown() {
		const dropdownContainer = this.block.querySelector('#sub-menu-navigation')
		const dropdown = this.block.querySelector('#sub-menu-dropdown')

		document.addEventListener('scroll', () => {
			dropdown.checked = false
		})

		window.addEventListener('click', (e) => {
			if(!dropdownContainer.contains(e.target)) {
				dropdown.checked = false
			}
		})
	},

	// Literal block initialize
	initializeBlock: function(block) {

		this.block = block
		this.innerBlock = block.querySelector('.menu-list')
		this.loadMoreWrapper = block.querySelector('.btn-load-more-wrapper')
		this.loadMoreBtn = block.querySelector('.load-more-btn')

		this.data.options = JSON.parse(this.innerBlock.dataset.options)

		this.initLoadMore() 
		this.initFilters()
		this.loadList()
		this.filterDropdown()


		window.addEventListener('resize', _.debounce(() => {
			if ( window.innerWidth != this.state.windowWidth ) {
				App.reset()
				App.loadList()
			}
		}, 250))
	},

	// Gutenberg initialize
	initializeBlockEditor: function(block) {
		App.initializeBlock(block[0])
	},

}

window.addEventListener('DOMContentLoaded', () => {
	App.state.windowWidth = window.innerWidth
	App.state.windowHeight = window.innerHeight

	const blocks = document.querySelectorAll('.elmntl-menu')
		
	blocks.forEach(block => {
		App.initializeBlock(block)
	})
})

if (window.acf) {
	window.acf.addAction(
		'render_block_preview/type=menu',
		App.initializeBlockEditor
	)
}
